export const NAME = "authModule" as string;
